import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type FeeSourceNotificationsSmsId = Branded<
    string,
    "FeeSourceNotificationsSmsId"
>;
const feeSourceNotificationsSmsIdPrefix = "fee_source_notifications_sms__";
const {
    factory: feeSourceNotificationsSmsIdFactory,
    assert: isFeeSourceNotificationsSmsId,
    zodSchema: feeSourceNotificationsSmsIdZodSchema,
} = genericId<FeeSourceNotificationsSmsId>(feeSourceNotificationsSmsIdPrefix);

export {
    feeSourceNotificationsSmsIdFactory,
    feeSourceNotificationsSmsIdPrefix,
    feeSourceNotificationsSmsIdZodSchema,
    isFeeSourceNotificationsSmsId,
};
export type { FeeSourceNotificationsSmsId };
